import { objectWithoutProperties as _objectWithoutProperties, toPropertyKey as _toPropertyKey, objectSpread2 as _objectSpread2, defineProperty as _defineProperty, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LOOKUP_RESET, LOOKUP_SET, SAVE_LOOKUP_STATE } from './actions.js';

var initialState = {};

var lookups = function lookups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SAVE_LOOKUP_STATE:
    case LOOKUP_SET:
      {
        var oldLookupState = state[action.name] || {};
        var oldKeyState = oldLookupState.keys || [];
        var newLookupState = oldKeyState.reduce(function (acc, key) {
          if (key !== action.key && (!action.limit || acc.keys.length < action.limit)) {
            acc.keys = [].concat(_toConsumableArray(acc.keys), [key]);
            acc[key] = oldLookupState[key];
          }

          return acc;
        }, _defineProperty({
          keys: [action.key]
        }, action.key, _objectSpread2(_objectSpread2({}, oldLookupState[action.key]), action.state)));
        return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.name, newLookupState));
      }

    case LOOKUP_RESET:
      {
        if (!action.name) {
          // reset all lookups
          return {};
        }

        if (action.key === undefined) {
          // reset all data for a lookup
          var _action$name = action.name;
          state[_action$name];

          var otherLookups = _objectWithoutProperties(state, [_action$name].map(_toPropertyKey));

          return otherLookups;
        } // reset specified key for a lookup


        var _oldLookupState = state[action.name] || {};

        var _action$key = action.key;
        _oldLookupState[_action$key];

        var _oldLookupState$keys = _oldLookupState.keys,
            keys = _oldLookupState$keys === void 0 ? [] : _oldLookupState$keys,
            otherKeys = _objectWithoutProperties(_oldLookupState, [_action$key, "keys"].map(_toPropertyKey));

        return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.name, _objectSpread2(_objectSpread2({}, otherKeys), {}, {
          keys: keys.filter(function (k) {
            return k !== action.key;
          })
        })));
      }

    default:
      return state;
  }
};

export { lookups as default };
